module.exports = __webpack_public_path__ + "img/22_50.19b34adb.png";